import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExpandMore = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_459_10788",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 6,
		y: 8,
		width: 12,
		height: 7,
		children: /* @__PURE__ */ _jsx("path", {
			d: "M12 14.6615C11.8795 14.6615 11.7673 14.6423 11.6635 14.6038C11.5597 14.5654 11.4609 14.4993 11.3674 14.4057L6.87313 9.91152C6.73466 9.77307 6.66383 9.59904 6.66063 9.38942C6.65741 9.1798 6.72824 9.00256 6.87313 8.8577C7.01799 8.71283 7.19363 8.6404 7.40003 8.6404C7.60643 8.6404 7.78206 8.71283 7.92693 8.8577L12 12.9308L16.0731 8.8577C16.2116 8.71925 16.3856 8.64841 16.5952 8.6452C16.8048 8.642 16.9821 8.71283 17.1269 8.8577C17.2718 9.00256 17.3443 9.1782 17.3443 9.38462C17.3443 9.59102 17.2718 9.76665 17.1269 9.91152L12.6327 14.4057C12.5391 14.4993 12.4404 14.5654 12.3366 14.6038C12.2327 14.6423 12.1205 14.6615 12 14.6615Z",
			fill: "#1C1B1F"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_459_10788)",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "#333333"
		})
	})]
});
export default SvgExpandMore;
